import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";
import filter from "lodash-es/filter";

Vue.use(Vuex);

interface RealestateOverview extends Vue {
    results: any[];
    sortedResults: any[];
}

const RealestateOverview = {
    template: "#realestateOverview",
    name: "RealestateOverview",
    computed: {
        results(this: RealestateOverview) {

            if(window.$$categories){
                const cats = window.$$categories;
                const categories = cats.split(",");

                const results = this.$store.state.realestateResults;
                this.sortedResults = [];

                for (let object of results) {
                    object['typeId'] = object.type ? object.type.id : '';
                }

                for (let category of categories) {
                    const results = this.$store.state.realestateResults;
                    this.sortedResults[category] = filter(results, { 'typeId': category });
                }
            }

            return this.sortedResults;

        },
    },
    mounted(this: RealestateOverview) {
        // Loads all
        this.$store.commit("updateSearch", { action: "realestate" });
    },
} as ComponentOptions<RealestateOverview>;

export { RealestateOverview };



// WEBPACK FOOTER //
// ./src/components/realestates-overview.ts